import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { DecayPeriod } from "../../types/decay";
import { DecayPeriodSelectorProps } from "../../types/decayPeriodSelector";

const DecayPeriodSelector = ({
  selectedPeriod,
  onChange,
  activeProfile,
}: DecayPeriodSelectorProps) => {
  if (activeProfile === null) {
    return null;
  }

  return (
    <div className="space-y-1">
      <Label>When was this interaction?</Label>
      <Select
        value={selectedPeriod}
        onValueChange={(v) => onChange(v as DecayPeriod)}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="q1">
            Within {activeProfile.q1_days} days
          </SelectItem>
          <SelectItem value="q2">
            {activeProfile.q1_days}–{activeProfile.q2_days} days ago
          </SelectItem>
          <SelectItem value="q3">
            {activeProfile.q2_days}–{activeProfile.q3_days} days ago
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default DecayPeriodSelector;
